import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpHelperService } from "@services/http-helper.service";
import { UserResponse } from "@shared/interfaces/user.model";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class AuthApiService {
  constructor(private readonly httpHelperService: HttpHelperService) {}

  public getUser(token: string): Observable<Partial<UserResponse>> {
    const params = new HttpParams().set("token", token);
    return this.httpHelperService.get("/auth/authenticate", params);
  }
}
